<div class="page-wrapper">
  <div class="container-fluid p-0">
    <!-- <div class="authentication-main mt-0"> -->
    <div class="row">
      <div class="col-12">
        <ng-template #loading>
          <p>Loading alarm details…</p>
        </ng-template>
        <div class="login-card">
          <div>
            <div>
              <a class="logo" routerLink="/">
                <img
                  class="img-fluid for-light"
                  src="https://image.makewebeasy.net/makeweb/m_1200x600/tgMg1U7WI/Home/logo_1_1.png"
                  alt="looginpage"
                />
              </a>
            </div>
            <div class="login-main">
              <!-- <ng-container *ngIf="alarm$ | async as alarm; else loading">
                <h2>Alarm {{ alarm.id }}</h2>
                <p>Station: {{ alarm.stationCode }}</p>
                <p>Time: {{ alarm.time | date: "short" }}</p>
                <p>Message: {{ alarm.message }}</p>
              </ng-container> -->
              <form *ngIf="alarm; else loading">
                <h6>Alarm Details</h6>

                <!-- Alarm Details Table START -->
                <div class="table-responsive">
                  <table class="table table-bordered">
                    <tbody>
                      <tr>
                        <th>Time</th>
                        <td>
                          {{
                            alarm.timestamp
                              | date: "yyyy-MM-dd HH:mm:ss" : "Asia/Bangkok"
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>Alarm</th>
                        <td>{{ alarm.alarmName }}</td>
                      </tr>

                      <tr>
                        <th>Station Name</th>
                        <td>{{ alarm.stationName }}</td>
                      </tr>
                      <!-- <tr>
                        <th>Station Code</th>
                        <td>{{ alarm.stationCode }}</td>
                      </tr> -->

                      <tr>
                        <th>Devices</th>
                        <td>{{ alarm.devName }}</td>
                      </tr>
                      <tr>
                        <th>Alarm Cause</th>
                        <td>{{ alarm.alarmCause }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!-- Alarm Details Table END -->
                <!-- <button
                  *ngIf="!showReasonInput && !alarm.muted"
                  class="btn btn-warning d-block w-100"
                  type="button"
                  (click)="showReasonInput = true"
                >
                  <strong>Mute This Alarm</strong>
                </button>
                <button
                  *ngIf="alarm.muted"
                  class="btn btn-warning d-block w-100"
                  type="button"
                  disabled
                >
                  <strong>Muted</strong>
                </button> -->

              <div class="d-flex gap-2 mb-3">
                <!-- Show ONLY if alarm.muted is null -->
                <ng-container *ngIf="alarm.muted === null && !showReasonInput">
                  <button
                    class="btn btn-light flex-fill"
                    type="button"
                    (click)="showReasonInput = true"
                  >
                    <strong>Mute This Alarm</strong>
                  </button>

                  <button
                    class="btn btn-warning flex-fill"
                    type="button"
                    (click)="notifyAlarm()"
                  >
                    <strong>Notify</strong>
                  </button>
                </ng-container>

                <!-- Show ONLY if alarm.muted is false -->
                <button
                  *ngIf="alarm.muted === false"
                  class="btn btn-warning d-block w-100"
                  type="button"
                  disabled
                >
                  <strong>Notified</strong>
                </button>

                <!-- Show ONLY if alarm.muted is true -->
                <button
                  *ngIf="alarm.muted === true"
                  class="btn btn-light d-block w-100"
                  type="button"
                  disabled
                >
                  <strong>Muted</strong>
                </button>
              </div>
                <!-- Reason Input + Save Button -->
                <div *ngIf="showReasonInput" class="form-group mt-3">
                  <label for="muteReason" class="form-label"
                    >Enter reason for muting:</label
                  >
                  <input
                    type="text"
                    id="muteReason"
                    name="muteReason"
                    [(ngModel)]="muteReason"
                    #muteReasonInput="ngModel"
                    required
                    class="form-control form-control-sm mb-1"
                    placeholder="Enter reason for muting"
                  />

                  <!-- Validation message -->
                  <div
                    *ngIf="
                      formSubmitted && (!muteReason || muteReason.trim() === '')
                    "
                    class="text-danger small mb-2"
                  >
                    Reason is required.
                  </div>

                  <!-- Follow Alarm Radio Buttons -->
                  <div class="mb-2">
                    <label class="form-label d-block">Follow This Alarm:</label>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="radio"
                        name="followAlarm"
                        id="followYes"
                        [value]="true"
                        [(ngModel)]="followAlarm"
                      />
                      <label class="form-check-label" for="followYes"
                        >Yes</label
                      >
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="radio"
                        name="followAlarm"
                        id="followNo"
                        [value]="false"
                        [(ngModel)]="followAlarm"
                      />
                      <label class="form-check-label" for="followNo">No</label>
                    </div>
                  </div>

                  <small class="text-muted d-block mt-1">
                    Followed alarms will be notified once cleared.
                  </small>

                  <button
                    class="btn btn-light w-100"
                    type="button"
                    (click)="saveMuteReason()"
                  >
                    Save and Mute Alarm
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- </div> -->
    <!-- Unlock page end-->
  </div>
</div>
